export const PREDEFINED_VENUES = ['Multipurpose Hall', 'Moot Court', 'A213', 'Sunken Court'];
